module.exports = __webpack_public_path__ + "img/nervioso.e045b609.png";